import { Input } from './ui/input';
import { Label } from './ui/label';
import { Building2 } from 'lucide-react';

export const BillingFieldsSection = ({ formData, setFormData }) => (
  <div className="pt-3 border-t border-border" data-testid="billing-fields-section">
    <p className="text-sm font-semibold flex items-center gap-2">
      <Building2 className="w-4 h-4 text-primary" />
      Datos de facturación
    </p>
    <p className="text-xs text-muted-foreground mt-0.5 mb-3">
      Los necesitamos para emitir la factura de tu compra.
    </p>
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-2" role="radiogroup" aria-label="Tipo de facturación">
      <button
        type="button"
        onClick={() => setFormData({ ...formData, billingType: 'particular', fiscalName: '' })}
        className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${
          formData.billingType === 'particular'
            ? 'border-primary bg-primary/10 text-primary'
            : 'border-border text-muted-foreground hover:bg-muted'
        }`}
        data-testid="billing-type-particular"
      >
        Particular
      </button>
      <button
        type="button"
        onClick={() => setFormData({ ...formData, billingType: 'empresa' })}
        className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${
          formData.billingType === 'empresa'
            ? 'border-primary bg-primary/10 text-primary'
            : 'border-border text-muted-foreground hover:bg-muted'
        }`}
        data-testid="billing-type-empresa"
      >
        Empresa
      </button>
      </div>
      {formData.billingType === 'particular' ? (
        <div>
          <Label htmlFor="taxId" className="input-label">DNI / NIE</Label>
          <Input
            id="taxId"
            type="text"
            className="input-field"
            value={formData.taxId}
            onChange={(e) => setFormData({ ...formData, taxId: e.target.value.toUpperCase() })}
            placeholder="Ejem: 12345678Z"
            required
            data-testid="register-tax-id"
          />
          <p className="text-[11px] text-muted-foreground mt-1">
            La factura se emitirá a tu nombre y apellidos.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="taxId" className="input-label">CIF</Label>
            <Input
              id="taxId"
              type="text"
              className="input-field"
              value={formData.taxId}
              onChange={(e) => setFormData({ ...formData, taxId: e.target.value.toUpperCase() })}
              placeholder="Ejem: B19718907"
              required
              data-testid="register-tax-id"
            />
          </div>
          <div>
            <Label htmlFor="fiscalName" className="input-label">Razón social</Label>
            <Input
              id="fiscalName"
              type="text"
              className="input-field"
              value={formData.fiscalName}
              onChange={(e) => setFormData({ ...formData, fiscalName: e.target.value })}
              placeholder="Ejem: Mi Empresa S.L."
              required
              data-testid="register-fiscal-name"
            />
          </div>
        </div>
      )}
      <div>
        <Label htmlFor="address" className="input-label">{formData.billingType === 'empresa' ? 'Dirección fiscal' : 'Dirección'}</Label>
        <Input
          id="address"
          type="text"
          className="input-field"
          value={formData.address}
          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
          placeholder="Calle, número, piso…"
          required
          data-testid="register-address"
        />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label htmlFor="postalCode" className="input-label">C. Postal</Label>
          <Input
            id="postalCode"
            type="text"
            inputMode="numeric"
            className="input-field"
            value={formData.postalCode}
            onChange={(e) => setFormData({ ...formData, postalCode: e.target.value })}
            placeholder="28001"
            required
            data-testid="register-postal-code"
          />
        </div>
        <div>
          <Label htmlFor="city" className="input-label">Ciudad</Label>
          <Input
            id="city"
            type="text"
            className="input-field"
            value={formData.city}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            placeholder="Madrid"
            required
            data-testid="register-city"
          />
        </div>
        <div>
          <Label htmlFor="province" className="input-label">Provincia</Label>
          <Input
            id="province"
            type="text"
            className="input-field"
            value={formData.province}
            onChange={(e) => setFormData({ ...formData, province: e.target.value })}
            placeholder="Madrid"
            required
            data-testid="register-province"
          />
        </div>
      </div>
    </div>
  </div>
);
